import { Container, Toolbar } from "@mui/material";
import { styled } from "@mui/system";
import PropTypes from "prop-types";
import React from "react";
import { HABILITA_CABECALHO } from "../../../shared/env";
import Header from "../../header/Header";
import Sessao from "../../operacional/Sessao";
import IdentificacaoSessao from "../../header/IdentificacaoSessao";

const habilitaCabecalho = HABILITA_CABECALHO === "S";

const Root = styled("div")({
  display: "flex",
  width: "100%"
});

const Main = styled("main")(({ theme }) => ({
  boxSizing: "border-box",
  flexGrow: 1,
  minWidth: 0,
  padding: habilitaCabecalho ? theme.spacing(0, 2, 12, 2) : 0
}));

function Page({ children, maxWidth = "md" }) {
  return (
    <Root>
      {habilitaCabecalho && <Header />}
      <Main>
        {habilitaCabecalho ? (
          <Toolbar sx={{ minHeight: { xs: 112, sm: 72 }, mb: 2 }} />
        ) : (
          <IdentificacaoSessao />
        )}
        <Container maxWidth={maxWidth} disableGutters={!habilitaCabecalho}>
          <Sessao />
          {children}
        </Container>
      </Main>
    </Root>
  );
}

Page.propTypes = {
  SidebarComponent: PropTypes.func,
  children: PropTypes.node.isRequired
};

export default Page;
